<app-bottom-sheet #sheet ariaLabel="تنظیمات سفارش" (closed)="onSheetClosed()">
	<ng-template #body>
		<div class="flex flex-col gap-3 text-3.25 font-medium text-gray-700" data-cy="order-settings-form">
			<!-- حجم پیش‌فرض خرید -->
			<div class="flex items-center justify-between gap-3">
				<label for="order-settings-buy-quantity">حجم پیش‌فرض خرید</label>
				<div class="w-1/2 max-w-40">
					<ui-input-number
						id="order-settings-buy-quantity"
						data-cy="order-settings-buy-quantity"
						[inputMode]="InputMode.money"
						[inputUnitRial]="false"
						[step]="1"
						[ngModel]="settingsForm.buyQuantity().value()"
						[ngModelOptions]="{ standalone: true }"
						(valueChanged)="onNumberInput(settingsForm.buyQuantity, $event)"
						(blurEvent)="onNumberBlur(settingsForm.buyQuantity)" />
				</div>
			</div>
			@if (buyQuantityError(); as error) {
				<p class="-mt-2 text-xs text-orange-400" role="alert" data-cy="order-settings-buy-quantity-error">
					{{ error }}
				</p>
			}

			<!-- حجم پیش‌فرض فروش -->
			<div class="flex items-center justify-between gap-3">
				<label for="order-settings-sell-quantity">حجم پیش‌فرض فروش</label>
				<div class="w-1/2 max-w-40">
					<ui-input-number
						id="order-settings-sell-quantity"
						data-cy="order-settings-sell-quantity"
						[inputMode]="InputMode.money"
						[inputUnitRial]="false"
						[step]="1"
						[ngModel]="settingsForm.sellQuantity().value()"
						[ngModelOptions]="{ standalone: true }"
						(valueChanged)="onNumberInput(settingsForm.sellQuantity, $event)"
						(blurEvent)="onNumberBlur(settingsForm.sellQuantity)" />
				</div>
			</div>
			@if (sellQuantityError(); as error) {
				<p class="-mt-2 text-xs text-orange-400" role="alert" data-cy="order-settings-sell-quantity-error">
					{{ error }}
				</p>
			}

			<!-- نوع تیک قیمت -->
			<div class="flex items-center justify-between gap-3">
				<span class="flex items-center gap-1">
					نوع تیک قیمت
					<button
						type="button"
						class="flex cursor-pointer items-center text-blue-500"
						aria-label="راهنمای تیک قیمت"
						data-cy="order-settings-tick-help"
						(click)="onTickHelpClick()">
						<ui-icon width="16" height="16" iconName="info-box-fill" />
					</button>
				</span>
				<ui-radio-group
					name="order-settings-tick-type"
					orientation="horizontal"
					structure="ltr"
					size="lg"
					data-cy="order-settings-tick-type"
					[formField]="settingsForm.tickType"
					[options]="tickTypeOptions" />
			</div>

			<!-- تیک قیمت -->
			<div class="flex items-center justify-between gap-3">
				<label for="order-settings-tick">تیک قیمت</label>
				<div class="w-1/2 max-w-40">
					<ui-input-number
						id="order-settings-tick"
						data-cy="order-settings-tick"
						[inputMode]="InputMode.decimal"
						[step]="tickStep()"
						[ngModel]="settingsForm.tick().value()"
						[ngModelOptions]="{ standalone: true }"
						(valueChanged)="onNumberInput(settingsForm.tick, $event)"
						(blurEvent)="onNumberBlur(settingsForm.tick)" />
				</div>
			</div>
			@if (tickError(); as error) {
				<p class="-mt-2 text-xs text-orange-400" role="alert" data-cy="order-settings-tick-error">
					{{ error }}
				</p>
			}

			<!-- تایید قبل از ارسال -->
			<ui-switch-toggle
				class="w-full"
				customClass="w-full justify-between"
				label="تایید قبل از ارسال"
				size="lg"
				data-cy="order-settings-order-confirmation"
				[formField]="settingsForm.orderConfirmation" />

			<!-- تایید قبل از حذف سفارش -->
			<ui-switch-toggle
				class="w-full"
				customClass="w-full justify-between"
				label="تایید قبل از حذف سفارش"
				size="lg"
				data-cy="order-settings-cancel-order-confirmation"
				[formField]="settingsForm.cancelOrderConfirmation" />

			<!-- گرفتن قیمت از سر خط -->
			<ui-switch-toggle
				class="w-full"
				customClass="w-full justify-between"
				label="گرفتن قیمت از سر خط"
				size="lg"
				data-cy="order-settings-price-from-headline"
				[formField]="settingsForm.priceFromHeadline" />

			@if (showHeadlineSideOptions()) {
				<ui-radio-group
					class="w-full"
					name="order-settings-price-from-headline-side"
					orientation="vertical"
					structure="ltr"
					size="lg"
					data-cy="order-settings-price-from-headline-side"
					[formField]="settingsForm.priceFromHeadlineSide"
					[options]="priceFromHeadlineSideOptions" />
			}

			<!-- نگهداری اطلاعات سفارش پس از ارسال -->
			<ui-switch-toggle
				class="w-full"
				customClass="w-full justify-between"
				label="نگهداری اطلاعات سفارش پس از ارسال"
				size="lg"
				data-cy="order-settings-keep-order-form"
				[formField]="settingsForm.keepOrderFormAfterSubmit" />

			@if (saveError(); as error) {
				<p class="text-xs text-orange-400" role="alert" data-cy="order-settings-save-error">
					{{ error }}
				</p>
			}
		</div>
	</ng-template>

	<ng-template #footer>
		<div class="flex w-full gap-2 py-4" data-cy="order-settings-actions">
			<ui-button
				type="button"
				class="min-w-0 flex-1"
				variant="green"
				size="lg"
				extraButtonClasses="w-full"
				label="ذخیره"
				data-cy="order-settings-save"
				[disabled]="!canSave()"
				[loading]="saving()"
				(clicked)="onSaveClick()" />
			<ui-button
				type="button"
				class="shrink-0 grow-0"
				variant="mute"
				size="lg"
				label="انصراف"
				data-cy="order-settings-cancel"
				(clicked)="onCancelClick()" />
		</div>
	</ng-template>
</app-bottom-sheet>

<app-bottom-sheet #tickHelpSheet ariaLabel="راهنمای تیک قیمت" [footerClass]="'py-4'" (closed)="onTickHelpClosed()">
	<ng-template #body>
		<div class="flex flex-col items-center gap-3 text-center" data-cy="order-settings-tick-help-content">
			<span class="inline-flex rounded bg-blue-500/10 p-2 text-blue-500">
				<ui-icon width="36" height="36" iconName="question-box" />
			</span>
			<span class="text-base font-bold text-gray-900">راهنما</span>
			<p class="text-3.25 font-medium text-gray-600">
				با تنظیم عدد تیک، با استفاده از دکمه‌های مخصوص کیبورد اختصاصی می‌توانید قیمت وارد شده در سفارش را تغییر
				دهید.
			</p>
		</div>
	</ng-template>

	<ng-template #footer>
		<ui-button
			type="button"
			class="w-full"
			variant="mofid"
			size="lg"
			extraButtonClasses="w-full"
			label="متوجه شدم"
			data-cy="order-settings-tick-help-dismiss"
			(clicked)="tickHelpSheet.close()" />
	</ng-template>
</app-bottom-sheet>
